import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  GetOrderDumpForManagerGQL,
  LookBook,
  LookBookOrder,
  LookBookProductConfig,
} from '../../graphql';
import {
  BehaviorSubject,
  Subject,
  combineLatest,
  map,
  pluck,
  startWith,
  switchMap,
  tap,
} from 'rxjs';

import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-look-book-order-details',
  templateUrl: './look-book-order-details.component.html',
  styleUrls: ['./look-book-order-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LookBookOrderDetailsComponent implements OnInit {
  @Input() lookBook: Pick<LookBook, 'lookBookId' | 'orders' | 'configs'>;
  @Input() index = 0;
  orderId$ = new BehaviorSubject<string>(null);
  reload$ = new Subject();
  productsDump$ = combineLatest([
    this.orderId$,
    this.reload$.pipe(startWith(true)),
  ]).pipe(
    tap((x) => console.log(x)),
    switchMap(([lookBookOrderId]) =>
      this.getOrderDumpForManagerGQL
        .fetch({
          variables: {
            lookBookOrderId,
            orderDate: this.order.date,
          },
        })
        .pipe(
          pluck('data', 'getLookBookOrderDump'),
          map(
            (products) => JSON.parse(products)[this.config.productsInPlay[0]],
          ),
        ),
    ),
  );
  productConfigDump$ = this.productsDump$.pipe(
    map((product) => JSON.parse(product.configuration)),
  );
  configs: Record<number, LookBookProductConfig> = {};
  pickedConfigs: Record<number, any> = {};
  hasDecoration$ = this.productConfigDump$.pipe(
    map((v) => {
      console.log(v);
      return v.find(({ type }) => type === 'decoration');
    }),
  );

  @Input() set orderId(orderId: string) {
    this.orderId$.next(orderId);
  }

  _order: LookBookOrder;

  get order() {
    if (!this._order) {
      this._order = this.lookBook.orders.find(
        ({ lookBookOrderId }) => lookBookOrderId === this.orderId$.value,
      );
    }
    return this._order;
  }

  get config() {
    if (!this.configs[this.index]) {
      this.configs[this.index] = this.lookBook.configs.find(
        (value) =>
          value.lookBookProductConfigId === this.order.configs[this.index],
      );
    }
    return this.configs[this.index];
  }

  get pickedConfig() {
    if (!this.pickedConfigs[this.index]) {
      this.pickedConfigs[this.index] = JSON.parse(this.config.valueMap);
    }
    return this.pickedConfigs[this.index];
  }

  constructor(
    private getOrderDumpForManagerGQL: GetOrderDumpForManagerGQL,
    private domSanitizer: DomSanitizer,
  ) {}

  sanitize(url) {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnInit(): void {}
}
